import React from 'react';
import { stringToNumber } from '../utils';

const CalculadoraUGP = ({ valoresUGP, setValoresUGP, setVistaActual }) => {
  // Cálculo de UGP
  const peso = stringToNumber(valoresUGP.pesoTotal);
  const grasas = stringToNumber(valoresUGP.grasasPor100);
  const hidratos = stringToNumber(valoresUGP.hidratosPor100);
  const proteinas = stringToNumber(valoresUGP.proteinasPor100);

  // Cálculos
  const grasasTotales = (grasas * peso) / 100;
  const proteinasTotales = (proteinas * peso) / 100;
  const hidratosTotales = (hidratos * peso) / 100;
  const kcalGrasas = grasasTotales * 9;
  const kcalProteinas = proteinasTotales * 4;
  const ugp = (kcalGrasas + kcalProteinas) / 150 ;
  const hc10 = hidratosTotales / 10;
  const total = ugp + hc10;

  return (
    <div className="w-full max-w-lg mx-auto p-6 bg-white rounded-xl shadow-lg">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-center text-indigo-600">Calculadora UGP</h1>
        <div className="mt-2 h-1 w-20 bg-indigo-500 mx-auto rounded-full"></div>
        <p className="mt-3 text-center text-gray-600 text-sm">Calcula las Unidades Grasas y Proteínas (UGP) de tu comida</p>
      </div>
      <div className="space-y-6 mb-8">
        <div>
          <label className="block text-xs font-medium text-gray-500 mb-1">Peso total de la comida (g)</label>
          <input
            type="text"
            inputMode="decimal"
            className="w-full p-2 border border-gray-200 rounded-lg text-sm focus:ring-2 focus:ring-indigo-200 focus:border-indigo-300 outline-none transition"
            value={valoresUGP.pesoTotal}
            onChange={e => setValoresUGP({ ...valoresUGP, pesoTotal: e.target.value })}
            placeholder="Ej: 250"
          />
        </div>
        <div className="flex gap-4">
          <div className="w-1/3">
            <label className="block text-xs font-medium text-gray-500 mb-1">Grasas/100g</label>
            <input
              type="text"
              inputMode="decimal"
              className="w-full p-2 border border-gray-200 rounded-lg text-sm focus:ring-2 focus:ring-indigo-200 focus:border-indigo-300 outline-none transition"
              value={valoresUGP.grasasPor100}
              onChange={e => setValoresUGP({ ...valoresUGP, grasasPor100: e.target.value })}
              placeholder="Ej: 12"
            />
          </div>
          <div className="w-1/3">
            <label className="block text-xs font-medium text-gray-500 mb-1">HC/100g</label>
            <input
              type="text"
              inputMode="decimal"
              className="w-full p-2 border border-gray-200 rounded-lg text-sm focus:ring-2 focus:ring-indigo-200 focus:border-indigo-300 outline-none transition"
              value={valoresUGP.hidratosPor100}
              onChange={e => setValoresUGP({ ...valoresUGP, hidratosPor100: e.target.value })}
              placeholder="Ej: 25"
            />
          </div>
          <div className="w-1/3">
            <label className="block text-xs font-medium text-gray-500 mb-1">Proteínas/100g</label>
            <input
              type="text"
              inputMode="decimal"
              className="w-full p-2 border border-gray-200 rounded-lg text-sm focus:ring-2 focus:ring-indigo-200 focus:border-indigo-300 outline-none transition"
              value={valoresUGP.proteinasPor100}
              onChange={e => setValoresUGP({ ...valoresUGP, proteinasPor100: e.target.value })}
              placeholder="Ej: 8"
            />
          </div>
        </div>
      </div>
      <div className="bg-gradient-to-r from-indigo-500 to-purple-500 p-5 rounded-lg shadow-md text-white mb-6">
        <h2 className="text-lg font-semibold text-center mb-4">Resultado UGP</h2>
        <div className="flex flex-col gap-2 text-base">
          <div className="flex justify-between"><span>Grasas:</span> <span>{grasasTotales.toFixed(1)} g <span className="text-xs">({kcalGrasas.toFixed(1)} kcal)</span></span></div>
          <div className="flex justify-between"><span>Proteínas:</span> <span>{proteinasTotales.toFixed(1)} g <span className="text-xs">({kcalProteinas.toFixed(1)} kcal)</span></span></div>
          <div className="flex justify-between"><span>Hidratos:</span> <span>{hidratosTotales.toFixed(1)} g</span></div>
          <hr className="my-2 border-indigo-200/40" />
          <div className="flex justify-between"><span>Raciones UGP:</span> <span>{isNaN(ugp) ? '0.0' : ugp.toFixed(1)}</span></div>
          <div className="flex justify-between"><span>Raciones HC*:</span> <span>{isNaN(hc10) ? '0.0' : hc10.toFixed(1)}</span></div>
          <hr className="my-2 border-indigo-200/40" />
          <div className="flex justify-between font-bold text-lg"><span>TOTAL (UGP + HC):</span> <span>{isNaN(total) ? '0.0' : total.toFixed(1)}</span></div>
        </div>
      </div>
      {/* <div className="flex justify-center">
        <button onClick={() => setVistaActual('calculadora')} className="bg-indigo-500 hover:bg-indigo-600 text-white py-2 px-6 rounded-lg transition-colors shadow-sm">Volver a la calculadora HC</button>
      </div> */}
      <div className="mt-6 text-xs text-gray-400 italic text-center">
      <p>*Cada ración de HC equivale a 10g de Hidratos de carbono.</p>
        <p>Consulta siempre con un profesional sanitario para una orientación personalizada.</p>
      </div>
    </div>
  );
};

export default CalculadoraUGP;
